import { baseState, baseMutations } from '@/store/mixins'
import monthlyAttendence from '@/api/human-resource/monthly-attendence'
import moment from 'moment'

export const state = {
    ...baseState,
    date_from: moment().format('DD-MM-YYYY'),
    date_to: moment().format('DD-MM-YYYY')
}
export const mutations = {
    ...baseMutations,
}
export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage
            },
            attrubutes
        )
        return monthlyAttendence.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    getDepartment(context, data) {
        return monthlyAttendence.department(data)
    },
    getEmployee(context, data) {
        return monthlyAttendence.employee(data)
    },
    getPosition(context, data) {
        return monthlyAttendence.position(data)
    },
    getHeader(context, params) {
        return monthlyAttendence.header({ params })
    },
    getHoliday(context, params) {
        return monthlyAttendence.holiday({ params })
    },
}